import React from "react";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/AddCircleOutlineRounded";
import FilterIcon from "@mui/icons-material/FilterAltOutlined";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

const buttonStyles = {
  infoButton: {
    color: "status.info",
  },
  editButton: {
    "&:hover, &:focus": {
      color: "status.info",
    },
  },
  deleteButton: {
    "&:hover, &:focus": {
      color: "status.danger",
    },
  },
};

const SuperUserFilterHeader = ({
  setDisplayCreateOrg,
  setDisplaySearchFilters,
  handleClose,
}) => {
  return (
    <Grid container spacing={3} id={"superuserpanel-header"}>
      <Grid size={6}>
        <Typography
          sx={{
            fontSize: ["1rem", "1rem", "1rem", "1rem", "1.5rem", "1.5rem"],
            my: [
              "0.25rem",
              "0.25rem",
              "0.25rem",
              "0.25rem",
              "0.5rem",
              "0.5rem",
            ],
          }}
        >
          Organizations
        </Typography>
      </Grid>
      <Grid size={1}>
        <Tooltip title={`Create Organization`}>
          <IconButton
            onClick={() => setDisplayCreateOrg(true)}
            sx={{
              ...buttonStyles.infoButton,
              padding: [
                "0.35rem",
                "0.35rem",
                "0.35rem",
                "0.5rem",
                "0.5rem",
                "0.5rem",
              ],
            }}
          >
            <AddIcon
              sx={{
                fontSize: [
                  "1.5rem",
                  "1.5rem",
                  "1.5rem",
                  "1.5rem",
                  "2rem",
                  "2rem",
                ],
              }}
            />
          </IconButton>
        </Tooltip>
      </Grid>
      <Grid size={1}>
        <Tooltip title={`Search Filters`}>
          <IconButton
            onClick={() => setDisplaySearchFilters(true)}
            sx={{
              ...buttonStyles.infoButton,
              padding: [
                "0.35rem",
                "0.35rem",
                "0.35rem",
                "0.5rem",
                "0.5rem",
                "0.5rem",
              ],
            }}
          >
            <FilterIcon
              sx={{
                fontSize: [
                  "1.5rem",
                  "1.5rem",
                  "1.5rem",
                  "1.5rem",
                  "2rem",
                  "2rem",
                ],
              }}
            />
          </IconButton>
        </Tooltip>
      </Grid>
      <Grid size={1} />
      <Grid size={1} />
      <Grid size={1}>
        <Tooltip title={`Close`}>
          <IconButton
            onClick={() => handleClose()}
            sx={{
              ...buttonStyles.infoButton,
              padding: [
                "0.35rem",
                "0.35rem",
                "0.35rem",
                "0.5rem",
                "0.5rem",
                "0.5rem",
              ],
            }}
          >
            <CloseIcon
              sx={{
                fontSize: [
                  "1.5rem",
                  "1.5rem",
                  "1.5rem",
                  "1.5rem",
                  "2rem",
                  "2rem",
                ],
              }}
            />
          </IconButton>
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default SuperUserFilterHeader;
